import storageUtils from '@/utils/storageUtils'
import { AUTH_NAME } from '@/utils/constants.js'
import { getConfigList } from '@/pages/admin/systemConfig/request'
import { SUCC_CODE } from '@/utils/constants'
import { comStatusType, configType } from '@/assets/enumerate/comEnumerate'

const clickoutside = {
  // 初始化指令
  bind(el, binding) {
    function documentHandler(e) {
      if (el.contains(e.target)) {
        return false
      }
      if (binding.expression) {
        binding.value(e)
      }
    }
    el.__vueClickOutside__ = documentHandler
    document.addEventListener('click', documentHandler)
  },
  unbind(el) {
    document.removeEventListener('click', el.__vueClickOutside__)
    delete el.__vueClickOutside__
  }
}
const mixin = {
  directives: { clickoutside },
  data() {
    return {
      AUTH_NAME,
      defaultImg: require('@/assets/images/errThumbnail.png')
    }
  },
  methods: {
    hasAuth(auth) {
      let user = storageUtils.getUser()
      if (!user || !user.userInfo) return false
      let ownAuthGroupIds = user.userInfo.authGroupIds
      let systemAuthGroupList = user.systemAuthGroupList
      let hasAuth = false
      if (systemAuthGroupList) {
        let sysAuthList = systemAuthGroupList.map(item => item.id)
        sysAuthList.forEach(item => {
          if (ownAuthGroupIds.indexOf(item) !== -1) {
            hasAuth = true
          }
        })
      }
      if (hasAuth) {
        return hasAuth
      }
      let ownAuthList = []
      ownAuthList = user.userInfo.auths || []
      return hasAuth || ownAuthList.includes(auth)
    },
    logout() {
      storageUtils.removeUser()
      this.$store.commit('clearAuthGroup')
      this.$store.commit('clearUser')
      this.$message.info('登录信息已过期，请重新登录')
      setTimeout(() => {
        this.$router.replace({ path: '/' })
      }, 1000)
    },
    newPage(page, pageSize, count) {
      if (
        count % pageSize === 1 &&
        page === Math.ceil(count / pageSize) &&
        count !== 1
      ) {
        page--
      }
      return page
    },
    // 获取系统配置
    async getSystemConfig() {
      let systemConfigList = []
      const params = { page: 1, pageSize: 100 }
      const { code, result } = await getConfigList(params)
      if (code === SUCC_CODE) {
        const list = result.list ? result.list : []
        systemConfigList = list.filter(item => item.status === comStatusType.up)
      }
      // 图片上传数量
      const picNum = systemConfigList.find(
        item => item.type === configType.picNum
      )
      // 模型举报类型
      const modelReport = systemConfigList.find(
        item => item.type === configType.modelReport
      )
      // 内容举报类型
      const contentReport = systemConfigList.find(
        item => item.type === configType.contentReport
      )
      // 评论举报类型
      const commentReport = systemConfigList.find(
        item => item.type === configType.commentReport
      )
      // 模型举报类型
      const userReport = systemConfigList.find(
        item => item.type === configType.userReport
      )
      // 模型及切片数量
      const modelGcodeNum = systemConfigList.find(
        item => item.type === configType.modelNum
      )
      // 模型及切片大小
      const modelGcodeSize = systemConfigList.find(
        item => item.type === configType.modelSize
      )
      // 模型审核原因
      const reviewModelReason = systemConfigList.find(
        item => item.type === configType.reviewModel
      )
      // 评分维度返回
      const scoreDimension = systemConfigList.find(
        item => item.type === configType.scoreDimension
      )
      // 创想币提现汇率
      const withdrawal = systemConfigList.find(
        item => item.type === configType.withdrawal
      )

      return {
        configPicNum: picNum ? picNum.picUploadNum : undefined,
        configModelReport: modelReport ? modelReport.reportTypes : undefined,
        configCommentReport: commentReport
          ? commentReport.reportTypes
          : undefined,
        configContentReport: contentReport
          ? contentReport.reportTypes
          : undefined,
        configUserReport: userReport ? userReport.reportTypes : undefined,
        configModelGcodeNum: modelGcodeNum
          ? modelGcodeNum.uploadNum
          : undefined,
        configModelGcodeSize: modelGcodeSize
          ? modelGcodeSize.uploadSize
          : undefined,
        reviewModelReason:
          reviewModelReason && reviewModelReason.settings
            ? reviewModelReason.settings.audit_failure
            : undefined,
        configReviewModelReason: reviewModelReason
          ? reviewModelReason
          : undefined,
        scoreDimension:
          scoreDimension && scoreDimension.settings
            ? scoreDimension.settings.scoreDimension
            : undefined,
        withdrawal:
          withdrawal && withdrawal.settings && withdrawal.settings.withdrawal
            ? withdrawal
            : undefined
      }
    }
  }
}

export { mixin }
